"use client";

import { ReactNode } from "react";
import { ThemeProvider, StoreProvider, Toaster } from "@oreme/ui";
import { RMapContextProvider } from "maplibre-react-components";
import { NextIntlClientProvider } from "next-intl";

interface ProviderProps {
  children: ReactNode;
  locale?: string;
  messages?: Record<string, undefined>;
}

function SharedProvider({
  children,
  locale,
  messages,
}: Readonly<ProviderProps>) {
  return (
    <>
      <StoreProvider>
        <ThemeProvider
          attribute="class"
          defaultTheme="system"
          enableSystem
          disableTransitionOnChange
        >
          <NextIntlClientProvider
            locale={locale}
            messages={messages}
            timeZone="Europe/Paris"
          >
            <RMapContextProvider>{children}</RMapContextProvider>
          </NextIntlClientProvider>
        </ThemeProvider>
      </StoreProvider>
      <Toaster />
    </>
  );
}

export { SharedProvider };
